import React, { Component } from 'react';
import { connect } from 'react-redux';
import style from './style.css';
import CSSModule from 'react-css-modules';
import { Link } from 'react-router';
import $ from 'jquery';
import moment from 'moment';
import Button from '../../component/button';
import Title from '../../component/title';

class MemberPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.handleClick = (e) => {
        }
    }   
    componentDidMount() {
    }   
    render() {
        const { user } = this.props;
        const type = user && user.level === 2 ? 'VIP':'一般';
        if( user.vip_expired ) var momentDay = moment(user.vip_expired).locale('zh-tw');
        const vipTime = momentDay ? momentDay.format('LL') : null;
        return (
            <div>
                <div styleName="banner">
                    {
                        type === '一般' ? <div styleName="welcome">您目前是一般會員，快加入 VIP 享受優質會員服務</div> : <div styleName="welcome">您目前是 { type } 會員，有效期限至 { vipTime }</div>
                    }
                    
                </div>
                <div styleName="calandar">
                    <Title>會員服務</Title>
                    <div>
                        <div styleName="card">
                            <Title styleName="title">一般會員</Title>
                            一般價格儲值點數<br/>
                            可以報名多堂課程<br/>
                            可以報名班級固定生
                        </div>
                        <div styleName="card">
                            <Title styleName="title">VIP會員</Title>
                            享有優惠價格儲值點數<br/>
                            可以報名多堂課程<br/>
                            可以報名班級固定生<br/>
                            插班候補通知服務<br/>
                            武學專用運動服裝一套<br/>
                            生日禮及不定期好禮
                            <a href="http://www.wulink.com.tw/member-service" target="_blank"><Button styleName="button">了解更多</Button></a>
                        </div>
                    </div>
                    
                </div>
                <Link to="/product/-1"><Button styleName="button">升級 VIP 會員</Button></Link>
            </div>
        );
    }
}

const mapStateToProps = state => {
	return {
        user: state.data.user
    };
}

export default connect(mapStateToProps, {  })(CSSModule(MemberPage,style, {allowMultiple:true}));




/** WEBPACK FOOTER **
 ** ./src/container/member/index.js
 **/